import { portfolioTypeSchema } from '@teo/types';
import { z } from 'zod';
import { displayId } from './common.js';
import { propertyOutputSchema } from './properties.js';
export const hoaFeaturesSchema = z.object({
    enableVoting: z.boolean().default(false).describe('Whether members can vote in TEOAI.'),
    enableDocuments: z.boolean().default(false).describe('Whether members can open documents.'),
    enableCommunications: z
        .boolean()
        .default(false)
        .describe('Whether TEOAI sends messages to members.'),
});
export const portfolioSettingsSchema = z.object({
    autoGenerateReports: z.boolean().default(false).describe('Whether TEOAI makes reports itself.'),
    enableTenantPortal: z.boolean().default(false).describe('Whether renters have a portal.'),
    hoaFeatures: hoaFeaturesSchema
        .optional()
        .describe('The member features of an association portfolio. Omit for other portfolios.'),
});
export const createPortfolioSchema = z.object({
    name: z
        .string({ error: 'Portfolio name is required' })
        .min(1, 'Portfolio name is required')
        .describe('The name of the portfolio.'),
    description: z.string().optional().describe('Notes about the portfolio.'),
    portfolioType: portfolioTypeSchema.describe('The kind of portfolio. An association ownership needs its own association type: hoa, coa or coop.'),
    ownershipId: z
        .string({ error: 'Ownership entity is required' })
        .min(1, 'Ownership entity is required')
        .describe('The display id of the ownership that the portfolio is for.'),
    settings: portfolioSettingsSchema
        .optional()
        .describe('The portfolio settings. Omit them to turn every feature off.'),
});
export const updatePortfolioSchema = z.object({
    portfolioId: displayId,
    name: z.string().min(1).optional().describe('The new name. Omit to keep it.'),
    description: z.string().optional().describe('The new notes. Omit to keep them.'),
    settings: portfolioSettingsSchema
        .optional()
        .describe('All the settings, which replace the old ones. Omit to keep them.'),
});
export const updatePortfolioOwnershipSchema = z.object({
    portfolioId: displayId,
    ownershipId: displayId,
});
export const addPropertyToPortfolioSchema = z.object({
    propertyId: displayId,
    portfolioId: displayId,
});
export const deletePortfolioSchema = z.object({
    portfolioId: displayId,
});
export const updatePortfolioOrderSchema = z.object({
    portfolioId: displayId,
    displayOrder: z
        .number()
        .int()
        .positive()
        .describe('The new position in the list, where 1 is the top.'),
});
export const movePropertyToPortfolioSchema = z.object({
    propertyId: displayId,
    targetPortfolioId: displayId,
});
export const getUserPortfoliosSchema = z.object({
    ownershipId: displayId.optional(),
});
export const portfolioOutputSchema = z.object({
    id: displayId,
    displayOrder: z.number(),
    ownershipId: displayId.optional(),
    accountingConnected: z.boolean().optional(),
    name: z.string(),
    description: z.string().nullable(),
    portfolioType: portfolioTypeSchema,
    settings: portfolioSettingsSchema.nullable(),
    properties: z.array(propertyOutputSchema).optional(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
//# sourceMappingURL=portfolios.js.map